import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
export const template = async (isFromTata) => {
    return {
        layout: {
            id: ROUTE.DIGIO_AUTOPAY_INPROGRESS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "mainContainerStack", type: WIDGET.STACK },
            ],
        },
        datastore: {
            mainContainerStack: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                padding: {
                    horizontal: SizeTypeTokens.XXXL
                },
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "space80", type: WIDGET.SPACE },
                    { id: "space42", type: WIDGET.SPACE },
                    { id: "lottieStack", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "headerText", type: WIDGET.TEXT },
                    { id: "space32", type: WIDGET.SPACE },
                    { id: "pointer1Stack", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer2Stack", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer3Stack", type: WIDGET.STACK },
                ]
            },
            headerText: {
                label: 'Waiting for AutoPay completion',
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '600',
                lineHeight: 24
            },
            space80: {
                size: SizeTypeTokens.Size80
            },
            space42: {
                size: SizeTypeTokens.SIZE42
            },
            space32: {
                size: SizeTypeTokens.Size32
            },
            spaceXL: {
                size: SizeTypeTokens.XL
            },
            pointer1Stack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "pointer1Index", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer1Text", type: WIDGET.TEXT }
                ]
            },
            pointer2Stack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "pointer2Index", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer2Text", type: WIDGET.TEXT }
                ]
            },
            pointer3Stack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "pointer3Index", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer3Text", type: WIDGET.TEXT }
                ]
            },
            pointer1Text: {
                label: 'You will be redirected to the bank page',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer2Text: {
                label: 'Approve AutoPay using bank details',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer3Text: {
                label: 'You will be redirected back to continue',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer1Index: {
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                maxWidth: 24,
                maxHeight: 24,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                bgColor: ColorTokens.Grey_Chalk,
                padding: {
                    all: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "pointer1IndexNumberText", type: WIDGET.TEXT }
                ]
            },
            pointer2Index: {
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                maxWidth: 24,
                maxHeight: 24,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                bgColor: ColorTokens.Grey_Chalk,
                padding: {
                    all: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "pointer2IndexNumberText", type: WIDGET.TEXT }
                ]
            },
            pointer3Index: {
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                maxWidth: 24,
                maxHeight: 24,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                bgColor: ColorTokens.Grey_Chalk,
                padding: {
                    all: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "pointer3IndexNumberText", type: WIDGET.TEXT }
                ]
            },
            pointer1IndexNumberText: {
                label: '1',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer2IndexNumberText: {
                label: '2',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer3IndexNumberText: {
                label: '3',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            lottieStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                alignContent: StackAlignContent.center,
                widgetItems: [
                    { id: "lottie", type: WIDGET.LOTTIE }
                ]
            },
            lottie: {
                uri: LottieTokens.SandTimer,
                size: LottieSizeTokens.XXL,
                autoplay: true,
                loop: true,
            },
        },
    };
};
export const digioAutoPayEntry = {
    onLoad: async ({ instrumentTrack, network, setDatastore }, { isFromTata }) => {
        return Promise.resolve(template(isFromTata));
    },
    clearPrevious: true,
};
